import { useState } from 'react'
import { usePhotoTopicsQuery } from '@/api/hooks/use-photo-topics'
import type { PhotoTopic } from '@/api/types/photo'
import { MultiSelectChipCombobox } from '@/components/app/panels/right-panel/combo-box/multi-select-chip-combobox'

export type SearchTopicsComboboxProps = {
  /** Selected topic tag ids (multi-select chips). */
  value: string[]
  onChange: (topicTagIds: string[]) => void
  onOpenChange?: (open: boolean) => void
}

function getTopicId(topic: PhotoTopic): string {
  return topic.topicTagId
}

function getTopicLabel(topic: PhotoTopic): string {
  return topic.displayName
}

function topicMatchesSearch(topic: PhotoTopic, query: string): boolean {
  return topic.displayName.toLowerCase().includes(query.toLowerCase())
}

export function SearchTopicsCombobox({ value, onChange, onOpenChange }: SearchTopicsComboboxProps) {
  const [open, setOpen] = useState(false)

  function handleOpenChange(next: boolean) {
    setOpen(next)
    onOpenChange?.(next)
  }

  const {
    data: topics = [],
    isLoading,
    isError,
    error,
  } = usePhotoTopicsQuery({
    enabled: open || value.length > 0,
  })

  return (
    <MultiSelectChipCombobox
      value={value}
      onChange={onChange}
      items={topics}
      getId={getTopicId}
      getLabel={getTopicLabel}
      matchesSearch={topicMatchesSearch}
      triggerLabel="Search topics"
      searchPlaceholder="Search topics"
      loadingMessage="Loading topics…"
      errorMessage={error instanceof Error ? error.message : 'Failed to load topics'}
      chipsTestId="topic-filter-chips"
      isLoading={isLoading}
      isError={isError}
      open={open}
      onOpenChange={handleOpenChange}
    />
  )
}
